import { render } from "./ContaReceberIndex.vue?vue&type=template&id=c8f2969a&scoped=true&ts=true"
import script from "./ContaReceberIndex.vue?vue&type=script&lang=ts"
export * from "./ContaReceberIndex.vue?vue&type=script&lang=ts"

import "./ContaReceberIndex.vue?vue&type=style&index=0&id=c8f2969a&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8f2969a"]])

export default __exports__